module.exports = __webpack_public_path__ + "static/img/organizationNum.7d9e4eab.png";